import { render, staticRenderFns } from "./Devs.vue?vue&type=template&id=53b54f5c&scoped=true&"
import script from "./Devs.vue?vue&type=script&lang=js&"
export * from "./Devs.vue?vue&type=script&lang=js&"
import style0 from "./Devs.vue?vue&type=style&index=0&id=53b54f5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b54f5c",
  null
  
)

export default component.exports